let addAlertRef = null

export const alertsBridge = {
    register(fn) {
        addAlertRef = fn
    },
    unregister() {
        addAlertRef = null
    },
    addAlert(alert) {
        if (addAlertRef) {
            addAlertRef(alert)
        } else {
            console.warn('alertsBridge: addAlert called before SnackBarProvider mounted', alert)
        }
    },
}
